import { createElement } from 'react'
import { Table } from 'shared/components'
import fp from 'lodash/fp'
import { createInWinImage } from 'shared/components/table/cellRenderers'
import { TournamentLogoCell } from './components/tournamentLogoCell'
import { TriggerCellComponent } from './components/triggerCell'
import { StatusCellComponent } from './components/statusCell'
import { ReceiptCellComponent } from './components/receiptCell'

export const createColumns = (loggedEntity) => [
  {
    Header: 'TOURNAMENTS',
    accessor: fp.identity('triggerDTO.eventDTO.tournamentDTO'),
    Cell: TournamentLogoCell,
    minWidth: 140,
    width: 140,
  },
  {
    Header: 'Beneficiary',
    accessor: 'beneficiaryDTO.logo',
    Cell: createInWinImage,
    width: 120,
    minWidth: 120,
  },
  {
    Header: 'Trigger',
    accessor: 'triggerDTO',
    minWidth: 580,
    width: 580,
    Cell: TriggerCellComponent,
  },
  {
    Header: 'Date of placing',
    accessor: 'date',
    Cell: Table.CellRenderers.DateTimeCell,
    minWidth: 200,
    width: 200,
  },
  {
    Header: 'Amount',
    accessor: 'fullAmount',
    Cell: Table.CellRenderers.MoneyValueCell,
    minWidth: 80,
  },
  {
    Header: 'Status',
    id: 'status',
    accessor: ({ stateDescription }) =>
      stateDescription === 'WIN' ? 'Played' : 'Not Played',
    Cell: StatusCellComponent,
  },
  {
    Header: 'Receipt',
    id: 'receipt',
    accessor: ({ stateDescription, id }) => {
      const address = loggedEntity?.address
      const hasAddress = Boolean(
        address?.address1 && address?.city && address?.zip && address?.country
      )
      return {
        stateDescription,
        hasAddress,
        id,
      }
    },
    Cell: ReceiptCellComponent,
    minWidth: 120,
  },
]
